module.exports = __webpack_public_path__ + "static/media/espn_alt.a8860870.png";